"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateVoucherForm = CreateVoucherForm;
exports.EditVoucherForm = EditVoucherForm;
exports.ResolveVoucherForm = ResolveVoucherForm;
var _react = _interopRequireDefault(require("react"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdFormik = require("cccisd-formik");
var _info = _interopRequireDefault(require("cccisd-icons/info"));
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _excluded = ["field", "form"],
  _excluded2 = ["field", "form"],
  _excluded3 = ["durationMonths", "useCustomDuration"],
  _excluded4 = ["field", "form"],
  _excluded5 = ["field", "form"],
  _excluded6 = ["durationMonths", "useCustomDuration"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
function CreateVoucherForm(_ref) {
  var sku = _ref.sku,
    closeModal = _ref.closeModal;
  function handleSubmit(_x) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var durationMonths, useCustomDuration, values, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            durationMonths = _ref2.durationMonths, useCustomDuration = _ref2.useCustomDuration, values = _objectWithoutProperties(_ref2, _excluded3);
            _context.next = 3;
            return _cccisdAxios["default"].post(Boilerplate.route('licensing.api.voucher.purchase'), _objectSpread(_objectSpread({}, values), {}, {
              purchases: _defineProperty({}, sku, values.quantity),
              sendEmail: false
            }, useCustomDuration ? {
              durationMonths: durationMonths
            } : {}));
          case 3:
            res = _context.sent;
            if (!res.error) closeModal();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert alert-info"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement(_info["default"], {
    spaceRight: true
  }), 'Note: '), "Emails are not sent to recipients upon manual voucher creation.")), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: {
      quantity: 1,
      durationMonths: 1
    },
    onSubmit: handleSubmit
  }, function (_ref3) {
    var values = _ref3.values;
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "firstName",
      label: "First Name",
      component: _cccisdFormik.CccisdInput
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "lastName",
      label: "Last Name",
      component: _cccisdFormik.CccisdInput
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-12"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "email",
      label: "Customer Email",
      component: _cccisdFormik.CccisdInput
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "quantity",
      label: "Initial License Quantity",
      component: _cccisdFormik.CccisdInput,
      type: "number"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "useCustomDuration"
    }, function (_ref4) {
      var useCustomDurationField = _ref4.field,
        form = _ref4.form,
        rest = _objectWithoutProperties(_ref4, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
        label: /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("strong", null, "Use Custom License Duration"), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "If set, any license redeemed from this voucher will use this value for the duration (in months) instead of the default value set on the Licensed Product."
        }, /*#__PURE__*/_react["default"].createElement(_question["default"], {
          spaceLeft: true
        }))),
        field: useCustomDurationField,
        form: form
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          gap: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], _extends({}, useCustomDurationField, {
        form: form
      }, rest, {
        style: {
          position: 'relative',
          top: '0'
        }
      })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "durationMonths"
      }, function (_ref5) {
        var durationMonthsField = _ref5.field,
          durationMonthsForm = _ref5.form,
          props = _objectWithoutProperties(_ref5, _excluded2);
        return /*#__PURE__*/_react["default"].createElement("input", _extends({}, durationMonthsField, props, {
          type: "number",
          step: "1",
          min: "1",
          className: "form-control",
          style: {
            visibility: "".concat(values.useCustomDuration ? 'visible' : 'hidden')
          }
        }));
      })));
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-12"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "notes",
      label: "Admin Notes",
      component: _cccisdFormik.CccisdTextarea,
      rows: "3"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      onClick: closeModal,
      className: "btn btn-link"
    }, "Cancel"), /*#__PURE__*/_react["default"].createElement("button", {
      type: "submit",
      className: "btn btn-primary"
    }, "Submit")));
  }));
}
function EditVoucherForm(_ref6) {
  var voucherId = _ref6.voucherId,
    initialValues = _ref6.initialValues,
    closeModal = _ref6.closeModal;
  function handleSubmit(_x2) {
    return _handleSubmit2.apply(this, arguments);
  }
  function _handleSubmit2() {
    _handleSubmit2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref7) {
      var durationMonths, useCustomDuration, values, res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            durationMonths = _ref7.durationMonths, useCustomDuration = _ref7.useCustomDuration, values = _objectWithoutProperties(_ref7, _excluded6);
            _context2.next = 3;
            return _cccisdAxios["default"].put(Boilerplate.route('licensing.api.voucher.update', {
              voucher: voucherId
            }), _objectSpread(_objectSpread({}, values), useCustomDuration ? {
              durationMonths: durationMonths
            } : {
              durationMonths: null
            }));
          case 3:
            res = _context2.sent;
            if (!res.error) closeModal();
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _handleSubmit2.apply(this, arguments);
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: initialValues,
    onSubmit: handleSubmit
  }, function (_ref8) {
    var values = _ref8.values;
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "firstName",
      label: "First Name",
      component: _cccisdFormik.CccisdInput
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "lastName",
      label: "Last Name",
      component: _cccisdFormik.CccisdInput
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-12"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "email",
      label: "Customer Email",
      component: _cccisdFormik.CccisdInput
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "quantity",
      label: "License Quantity",
      component: _cccisdFormik.CccisdInput,
      type: "number"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "useCustomDuration"
    }, function (_ref9) {
      var useCustomDurationField = _ref9.field,
        form = _ref9.form,
        rest = _objectWithoutProperties(_ref9, _excluded4);
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
        label: /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("strong", null, "Use Custom License Duration"), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "If set, any license redeemed from this voucher will use this value for the duration (in months) instead of the default value set on the Licensed Product."
        }, /*#__PURE__*/_react["default"].createElement(_question["default"], {
          spaceLeft: true
        }))),
        field: useCustomDurationField,
        form: form
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          gap: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], _extends({}, useCustomDurationField, {
        form: form
      }, rest, {
        style: {
          position: 'relative',
          top: '0'
        }
      })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "durationMonths"
      }, function (_ref10) {
        var durationMonthsField = _ref10.field,
          durationMonthsForm = _ref10.form,
          props = _objectWithoutProperties(_ref10, _excluded5);
        return /*#__PURE__*/_react["default"].createElement("input", _extends({}, durationMonthsField, props, {
          type: "number",
          step: "1",
          min: "1",
          className: "form-control",
          style: {
            visibility: "".concat(values.useCustomDuration ? 'visible' : 'hidden')
          }
        }));
      })));
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-12"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "notes",
      label: "Admin Notes",
      component: _cccisdFormik.CccisdTextarea,
      rows: "3"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      onClick: closeModal,
      className: "btn btn-link"
    }, "Cancel"), /*#__PURE__*/_react["default"].createElement("button", {
      type: "submit",
      className: "btn btn-primary"
    }, "Submit")));
  });
}
function ResolveVoucherForm(_ref11) {
  var voucherId = _ref11.voucherId,
    initialValues = _ref11.initialValues,
    closeModal = _ref11.closeModal;
  function handleSubmit(_x3) {
    return _handleSubmit3.apply(this, arguments);
  }
  function _handleSubmit3() {
    _handleSubmit3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(values) {
      var res;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _cccisdAxios["default"].put(Boilerplate.route('licensing.api.voucher.update', {
              voucher: voucherId
            }), _objectSpread(_objectSpread({}, values), {}, {
              resolved: true
            }));
          case 2:
            res = _context3.sent;
            if (!res.error) closeModal();
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _handleSubmit3.apply(this, arguments);
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: initialValues,
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-lg-12"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "notes",
    label: "Admin Notes",
    component: _cccisdFormik.CccisdTextarea,
    rows: "3"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: closeModal,
    className: "btn btn-link"
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "submit",
    className: "btn btn-primary"
  }, "Resolve"))));
}